import _ from '@sparta.global.vendors/lodash';
import $ from '@sparta.global.vendors/jquery';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "boa-social-skin--"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1), depth0));
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "boa-social-size--"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"size") : stack1), depth0));
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "boa-social-shape--"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"shape") : stack1), depth0));
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    data-externalSite="
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"externalSite") : stack1), depth0))
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div\r\n  class=\"\r\n    boa-social-target\r\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":4,"column":62}}})) != null ? stack1 : "")
    + "\r\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"size") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":5,"column":62}}})) != null ? stack1 : "")
    + "\r\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"shape") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":6,"column":65}}})) != null ? stack1 : "")
    + "\r\n  \"\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"externalSite") : stack1),"==",true,{"name":"compare","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":2},"end":{"line":10,"column":14}}})) != null ? stack1 : "")
    + "  data-sparta=\"Sparta\"\r\n  data-global-social-module-version=\"v1.0.0\"\r\n  data-config='"
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"globalContent") : depth0)) != null ? lookupProperty(stack1,"socialDefaults") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":13,"column":15},"end":{"line":13,"column":52}}}))
    + "'\r\n></div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global.modules/global-social-module",
  "version": "1.1.30",
  "id": "globalSocialModule",
  "containerID": "globalSocialModule",
  "moduleName": "global-social-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "global-social-module",
  "data": {
    "init": "GlobalSocialModule",
    "options": {
      "branding": "{{module.branding}}",
      "externalSite": "{{module.externalSite}}",
      "socialEnabled": "{{module.socialEnabled}}",
      "socialType": "{{module.socialType}}"
    }
  },
  "moduleParams": [{
    "name": "skin",
    "type": "string",
    "values": ["white"],
    "default": null,
    "description": "Overrides styles to change skin theme."
  }, {
    "name": "socialEnabled",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Global switch for social functionality.  Set to false to disable social module at build time."
  }, {
    "name": "externalSite",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter controls if the social module is loaded by an external site so that it will pick up additional options."
  }, {
    "name": "branding",
    "type": "string",
    "values": ["red", "blue", "grey", "white"],
    "default": "red",
    "description": "Sets the interstitial modal branding to be used by the social module."
  }, {
    "name": "size",
    "type": "string",
    "values": ["large", "small"],
    "default": "large",
    "description": "Sets the size of social icons large (30x30 legacy support) and small (24x24)"
  }, {
    "name": "shape",
    "type": "string",
    "values": ["square", "round"],
    "default": "square",
    "description": "Display social icons as square (legacy support) or round svg"
  }, {
    "name": "socialType",
    "type": "string",
    "values": ["follow", "share"],
    "default": "follow",
    "description": "Configures how social module should appear"
  }, {
    "name": "isChild",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": ""
  }, {
    "name": "site",
    "type": "string",
    "values": ["sparta"],
    "default": false,
    "description": ""
  }, {
    "name": "networks",
    "type": "object",
    "default": {},
    "description": ""
  }, {
    "name": "analyticsId",
    "type": "string",
    "default": "link",
    "description": "An ID/Flag to append to the end of links within the module"
  }, {
    "name": "headerTag",
    "type": "string",
    "values": ["div", "h1", "h2", "h3", "h4", "h5", "h6"],
    "default": "div",
    "description": "Specifies which HTML tag the header will use."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        compare,
        json
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    compare,
    json
  },
  "dependencies": {
    "@sparta.global.helpers/comparisons-helper": "^1.0.5",
    "@sparta.global.helpers/json-helper": "^1.0.4",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.10",
    "@sparta.global.utilities/sparta-module-utility": "^1.1.16",
    "@sparta.global.utilities/sparta-color-style-token-utility": "^1.0.4",
    "@sparta.global.utilities/sparta-spacing-style-token-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-global-style-token-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-font-style-token-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-breakpoint-style-token-utility": "^1.0.2",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.1.48",
    "@sparta.global.vendors/jquery": "^3.5.1",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.global.vendors/handlebars": "^4.7.7"
  },
  "stores": []
};

/* global bactm_cmCreateManualLinkClickTag bactm_cmCreatePageviewTag cG7 cm_ClientID
  cmCreateManualLinkClickTag cmCreatePageviewTag cX */


/**
 * Handles the display of the social media icons.
 */
class GlobalSocialModule extends Module {
  /**
   * Creates an instance of the module.
   * @param {object} options - The options this module was initialized with.
   * @param {object} context - Context for the module.
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {void}
   */
  init() {
    const genericURL = document.querySelector("[rel='canonical']") ? document.querySelector("[rel='canonical']").href : window.location.href;
    const defaults = {
      socialDebug: false,
      socialEnabled: 'true',
      // Toggle for entire feature.
      socialType: 'follow',
      socialTarget: '.boa-social-target',
      // To inject social links and JCR inside data attributes.
      $socialTarget: '',
      socialModule: '.boa-social-module',
      // Sparta parent module sets page options.
      $socialModule: '',
      socialLoader: '.boa-social-loader',
      // External wrapper (Borneo) customizes external pages.
      $socialLoader: '',
      branding: 'red',
      lang: 'en',
      content: {},
      platform: 'sparta',
      site: '',
      externalSite: false,
      runtimeConfig: {},
      dataCollection: {
        cmEnabled: false,
        currentPageURL: '',
        currentPageID: '',
        pageCategoryID: 'ENT:Tool:Social' // May be modified later to append "Follow" or "Share."
      },
      networks: {
        twitter: {
          sharing: {
            link: 'https://x.com/intent/tweet?text=%TITLE%&url=%URL%',
            url: genericURL,
            title: ''
          }
        },
        x: {
          sharing: {
            link: 'https://x.com/intent/tweet?text=%TITLE%&url=%URL%',
            url: genericURL,
            title: ''
          }
        },
        facebook: {
          sharing: {
            link: 'https://www.facebook.com/sharer/sharer.php?u=%URL%&title=%TITLE%&description=%SUMMARY%&picture=%PICTURE%',
            url: genericURL,
            title: '',
            summary: '',
            picture: ''
          }
        },
        linkedin: {
          sharing: {
            link: 'https://www.linkedin.com/shareArticle?&mini=true&ro=false&url=%URL%&title=%TITLE%&summary=%SUMMARY%',
            url: genericURL,
            title: '',
            summary: ''
          }
        }
      }
    };

    // Set default page language.
    defaults.lang = document.documentElement.lang === 'es-US' ? 'es' : 'en';

    /*
      Create `settings` objects by extending various options wtih deep copy. Here is the order:
        1. check data-init properties
      2. JCR data
      3. custom meta property
      4. canonical link
      5. window.location
    */

    // Check for custom meta properties on the page next.
    [].slice.call(document.querySelectorAll("[name^='sparta:url']")).forEach(value => {
      const propertyArray = value.attributes.name.value.split(':');
      const currentNetwork = propertyArray[propertyArray.length - 1].toLowerCase();
      if (defaults.networks[currentNetwork] && defaults.networks[currentNetwork].sharing) {
        defaults.networks[currentNetwork].sharing.url = value.attributes.content.value;
      }
    });

    // Get defaults loaded.
    const tempSettings = defaults;
    _.merge(tempSettings, defaults);
    this.settings = _.merge(tempSettings, this.settings);

    // Set target of items.
    if (this.settings.$socialModule) {
      this.settings.$socialTarget = $(this.settings.socialTarget, this.settings.$socialModule);
    } else if (Array.isArray(this.applicationContainer)) {
      const targets = [];
      this.settings.containerTargetArr = [];
      this.applicationContainer.forEach((currentContainer, index) => {
        const currentTarget = $(this.settings.socialTarget, currentContainer);
        this.settings.containerTargetArr[index] = currentContainer;
        if (currentTarget && currentTarget.length === 1) {
          targets.push(currentTarget[0]);
        }
      });
      this.settings.$socialTarget = $(targets);
    } else if (!this.isWidget) {
      this.settings.$socialTarget = $(this.settings.socialTarget, this.settings.target);
    } else {
      this.settings.$socialTarget = $(this.settings.socialTarget, this.applicationContainer);
    }
    const jcrData = this.settings.$socialTarget.data('config') || {};

    // Update settings. Include `jcrData`, then anything from `arguments/options/overrides`.
    _.merge(this.settings, jcrData, this.params, this.settings.moduleInfo.options);

    // Set up sharing links.
    this.isSharing = this.settings.socialType === 'sharing';
    if (this.isSharing) {
      this.setupShareLinks();
    }

    // Set up `dataCollection` ID.
    if (this.settings.dataCollection && this.settings.dataCollection.pageCategoryID && this.settings.dataCollection.pageCategoryID === defaults.dataCollection.pageCategoryID) {
      this.settings.dataCollection.pageCategoryID += this.settings.socialType === 'follow' ? 'Follow' : 'Share';
    }

    // Set up analytics append ID.
    this.settings.analyticsId = this.settings.analyticsId && this.settings.analyticsId ? `_${this.settings.analyticsId.trim()}` : this.settings.analyticsId || '';

    // Stop if Social is turned off anywhere. `socialEnabled` is a module config param.
    // `socialEnabledContent` is a JCR param that can be overridden via site content or Borneo
    // `pageview` param.
    if (!this.settings.socialEnabled || this.settings.socialEnabled === 'false' || this.settings.enableSocialContent === false || this.settings.runtimeConfig && this.settings.runtimeConfig.socialEnabled === false) {
      this.settings.$target.append('<span class="socialIsDisabled"></span>');
      return;
    }
    [].slice.call(this.settings.$socialTarget).forEach((appContainer, index, arr) => {
      this.createSocialModule(this.isSharing, $(appContainer), arr.length > 1 ? index + 1 : NaN);
      // Legacy framework boaSocialUtilJS utility fn call for isExternal
      if (appContainer.getAttribute('data-externalSite') === 'true' && typeof boaSocialUtilJS === 'function') {
        boaSocialUtilJS.init();
      }
    });
  }
  setupShareLinks() {
    Object.keys(this.settings.networks).forEach(networkName => {
      const currentNetwork = this.settings.networks[networkName];
      if (currentNetwork && currentNetwork.sharing && currentNetwork.sharing.link) {
        const currentShare = currentNetwork.sharing;
        currentShare.link = currentShare.link.replace('%URL%', currentShare.url || '');
        currentShare.link = currentShare.link.replace('%TITLE%', currentShare.title || '');
        currentShare.link = currentShare.link.replace('%SUMMARY%', currentShare.summary || '');
        currentShare.link = currentShare.link.replace('%PICTURE%', currentShare.picture || '');
      }
    });
  }

  // createSocialModule: Create Social Module based on settings.
  createSocialModule(useShareLinks, appContainer, itemIndex = NaN) {
    let html = `
      <div class="boa-social boa-social--follow boa-social--clearfix">
      <${this.settings.headerTag} class="boa-social--header">
        ${this.settings.content[useShareLinks ? 'share' : 'connectWithUs']}
      </${this.settings.headerTag}>
    `;

    // Output structured markup tag.
    let structuredMarkup = `
      <div itemscope="itemscope" itemtype="http://schema.org/Organization">
      <link class="spa-hidden" itemprop="url" href="https://www.bankofamerica.com"></link>
    `;

    // Start list order dom inject. Will get closed prior to structured markup setter.
    html += '<ul>';

    // Loop over each network.
    for (let i = 0; i < this.settings.networkOrder.length; i++) {
      const network = this.settings.networkOrder[i];
      const networkObj = this.settings.networks[network];
      const linkID = `social_${this.settings.socialType.toLowerCase()}_${networkObj.class}${this.settings.analyticsId}${itemIndex || ''}`;
      let link;
      // TODO: Add social type to ID.

      if (useShareLinks) {
        if (networkObj.sharing && networkObj.sharing.link) {
          ({
            link
          } = networkObj.sharing);
        } else {
          continue; // Only display those networks that have sharing options set.
        }
      } else if (network === 'twitter') {
        // If Twitter, grab BofA handle.
        link = networkObj.links['@BankofAmerica'] || {};
        ({
          link
        } = link);
      } else {
        ({
          link
        } = networkObj.links[network]);
      }

      // Check for undefined.
      if (typeof link === 'undefined') {
        link = '';
      }

      // Check if network is enabled by global settings and global chicken switch.
      if (!networkObj.enabled || this.settings.runtimeConfig && this.settings.runtimeConfig[network] === false) {
        continue;
      }

      // Output structured markup.
      structuredMarkup += `<a class="spa-hidden" itemprop="sameAs" href="${link}">${networkObj.name}</a>`;

      // Retaining Legacy class.
      const twitterClass = network === 'twitter' ? ` boa-social--${network}` : '';
      html += `<li><a href="#" id="${linkID}" data-network="${networkObj.class}" class="boa-social--network boa-social--${networkObj.class}${twitterClass} spa-prevent-default-click" aria-label="${this.settings.content[useShareLinks ? 'shareOn' : 'connectWithUsOn']} ${networkObj.name} ${this.settings.content.adaOpen}">
        ${this.params.shape === 'round' ? networkObj.svgRound : networkObj.svg}
        </a></li>`;

      // Update SVG with module params.
      if (this.params.size === 'small') {
        html = html.replace(/viewBox="([^"]+)"/ig, 'viewBox="0 0 24 24"').replace(/width="([^"]+)"/ig, 'width="24"').replace(/height="([^"]+)"/ig, 'height="24"');
      }
    }
    structuredMarkup += '</div>';
    html += `</ul></div>${structuredMarkup}`;

    // Add each network to the page.
    appContainer.html(html);

    // Delegate click handling.
    appContainer.on('click', '.boa-social--network', event => {
      this.openSocialLayer.call(this, event, itemIndex, appContainer, useShareLinks);
    });

    // Update CM links.
    this.updateLinksDataCollection();
  }

  // openSocialLayer: Open UI Layer for a social icon.
  openSocialLayer(event, itemIndex, currentContainer, useShareLinks) {
    // Set $this to event target
    const $this = $(event.currentTarget);
    const modalId = `boaSocialModal${this.settings.analyticsId}${itemIndex || ''}`;

    // Destroy existing modal if opened (appends "SpartaUILayer" to the end like UI Layers adds).
    const $modalLayer = $(`#${modalId}SpartaUILayer`);
    if ($modalLayer.length) {
      $modalLayer.remove();
    }

    // This network info.
    const network = $this.data('network');
    const networkObj = this.settings.networks[network];
    const networkName = networkObj.name;
    const modalBranding = this.settings.branding;
    let networkLink;
    if (this.isSharing) {
      networkLink = networkObj.sharing.link;
    } else if (network === 'twitter') {
      // If Twitter, grab BofA handle.
      networkLink = networkObj.links['@BankofAmerica'] || {};
      networkLink = networkLink.link;
    } else {
      networkLink = networkObj.links[network].link;
    }
    const modalHeader = useShareLinks ? networkObj.content.sharingHeading : networkObj.content.connectHeading;
    const modalContent = `
      <div class="boa-social--interstitial ${''}">
        ${this.settings.content.interstitial1}${networkName}${this.settings.content.interstitial2}
      </div>
    `;

    // Modal data to pass to ui-layers.
    const modalData = {
      module: this.settings.moduleInfo.name,
      contentId: `${modalId}`,
      type: 'modal',
      branding: `${modalBranding}`,
      interstitial: {
        header: `${modalHeader}`,
        body: `${modalContent}`,
        btnText1: `${this.settings.content.continue}${networkObj.name}`,
        btnText2: `${this.settings.content.return}`,
        continueLink: `${networkLink}`
      }
    };
    const modalEvent = {
      currentTarget: $this,
      $applicationContainer: undefined
    };
    if (this.settings.platform === 'sparta') {
      // fix for widgetInfo check error
      if (this.widgetInfo) {
        spartaUILayersUtility.openLayer(modalData, modalEvent, null, this.widgetInfo.id);
      } else {
        spartaUILayersUtility.openLayer(modalData, modalEvent, null, null);
      }
      const uiModalId = modalId;
      spartaEventsUtility.sub(`${spartaUILayersUtility.EVENTS.MODAL_CLOSED}:${uiModalId}`, thisEvent => {
        if (thisEvent.data.contentId === uiModalId) {
          spartaEventsUtility.unsubByEvent(`${spartaUILayersUtility.EVENTS.MODAL_CLOSED}:${uiModalId}`);
          this.modalCloseDataCollection();
        }
      });
    } else if (this.settings.platform === 'borneo') {
      $(`${modalId}`).boaFlexModal({
        width: 500,
        closeTriggers: $(`#${modalId} .boa-social--button`),
        onClose() {
          this.modalCloseDataCollection();
        }
      });
    }

    // Modal is now open. Run data collection functions.
    this.modalOpenDataCollection(networkObj);

    // update CM links
    this.updateLinksDataCollection();
  }

  // Set up Coremetrics data collection on page.
  setupDataCollection() {
    if (typeof cmSetStaging === 'function') {
      this.settings.dataCollection.cmEnabled = true;
      this.settings.dataCollection.currentPageURL = window.location.href;
      this.settings.dataCollection.currentPageID = cG7.cM0[cm_ClientID];
      this.debug(`_setupDataCollection() save current page id for later.  cG7.cM0[cm_ClientID] = ${cG7.cM0[cm_ClientID]}`);
    }
  }

  // On modal open, call Coremetrics page view and manual link click tags.
  modalOpenDataCollection(networkObj) {
    // Check to see if CM is loaded.
    this.setupDataCollection();

    // Due to legacy CM functions.
    if (typeof cmCreatePageviewTag === 'undefined' && typeof bactm_cmCreatePageviewTag === 'function') {
      window.cmCreatePageviewTag = bactm_cmCreatePageviewTag;
    }
    if (typeof cmCreateManualLinkClickTag === 'undefined' && typeof bactm_cmCreateManualLinkClickTag === 'function') {
      window.cmCreateManualLinkClickTag = bactm_cmCreateManualLinkClickTag;
    }
    if (this.settings.dataCollection.cmEnabled && typeof cmCreatePageviewTag === 'function' && typeof cmCreateManualLinkClickTag === 'function') {
      // Wait to make sure natural CM link click fired before we fire new page view.
      this.debug(networkObj);
      cmCreatePageviewTag(networkObj.pageID, null, null, this.settings.dataCollection.pageCategoryID, false, false, null, false, false, null, null, null, null, null, null, null, null, null, null, this.settings.dataCollection.currentPageURL, null);
      // eslint-disable-next-line no-script-url
      cmCreateManualLinkClickTag('#', this.settings.dataCollection.currentPageID, networkObj.pageID);
      this.debug('_modalOpenDataCollection() - call cmCreatePageviewTag & cmCreateManualLinkClickTag');
    }
  }

  // On modal close, reset Coremetrics page ID.
  modalCloseDataCollection() {
    // Check to see if CM is loaded.
    if (this.settings.dataCollection.cmEnabled) {
      window.setTimeout(() => {
        cG7.cM0[cm_ClientID] = this.settings.dataCollection.currentPageID;
        this.debug(`_modalCloseDataCollection() reset page ID. cG7.cM0[cm_ClientID] = ${cG7.cM0[cm_ClientID]}`);
      }, 500);
    }
  }

  // Rescan DOM for Coremetrics to get new links.
  updateLinksDataCollection() {
    if (typeof cX === 'function') {
      cX('onload');
      this.debug('_updateLinksDataCollection(): cX scan for new links');
    }
  }
  debug(msg) {
    if (window.console && this.settings.socialDebug === true) {
      // eslint-disable-next-line no-console
      console.log(msg);
    }
  }
}
registerModuleClass({
  moduleClass: GlobalSocialModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { GlobalSocialModule as default, moduleConfig };
